import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { findAJobDropdownDataEn } from './findAJobDropdownData.en';
import { findAJobDropdownDataEs } from './findAJobDropdownData.es';
import { findAJobDropdownDataPt } from './findAJobDropdownData.pt';
import type { FindAJobDropdownData } from './types/FindAJobDropdownData';

export const findAJobDropdownDataByLocale: Record<
  I18nLocale,
  FindAJobDropdownData
> = {
  en: findAJobDropdownDataEn,
  es: findAJobDropdownDataEs,
  pt: findAJobDropdownDataPt,
};
